import React, { Component } from "react";
import { Table, Pagination, Col, Row, Button, Select, DatePicker } from "antd";
import PropTypes from "prop-types";
import moment from "moment";
import { strings } from "../../../helpers";

const { Option } = Select;
const { RangePicker } = DatePicker;

export default class PaymentsView extends Component {
  static propTypes = {
    payments: PropTypes.array.isRequired,
    currentPage: PropTypes.number.isRequired,
    totalRecords: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    toggleAddPaymentModal: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    onFilterChange: PropTypes.func.isRequired
  };

  handlePaymentTypeChange = value => {
    const { filters, onFilterChange } = this.props;
    onFilterChange({
      ...filters,
      payment_type: value
    });
  };

  handleDateRangeChange = (dates, dateStrings) => {
    const { filters, onFilterChange } = this.props;
    onFilterChange({
      ...filters,
      start_date: dateStrings[0] || null,
      end_date: dateStrings[1] || null
    });
  };
  render() {
    const {
      payments,
      currentPage,
      totalRecords,
      onPageChange,
      toggleAddPaymentModal,
      filters
    } = this.props;

    const columns = [
      {
        title: "Order ID",
        dataIndex: "order_id",
        key: "order_id",
        align: "left",
        width: 150,
        ellipsis: true,
        render: text => text || "-"
      },
      {
        title: "Payment ID",
        dataIndex: "razorpay_payment_id",
        key: "razorpay_payment_id",
        align: "left",
        width: 150,
        ellipsis: true,
        render: text => text || "-"
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
        align: "left",
        width: 120,
        ellipsis: true,
        render: text => text || "-"
      },
      {
        title: "Date & Time",
        dataIndex: "created_at",
        key: "created_at",
        align: "left",
        width: 140,
        render: date => {
          if (date) {
            return moment(date).format("DD MMM YYYY, h:mm A");
          }
          return "-";
        }
      },
      {
        title: "Contact",
        dataIndex: "contact",
        key: "contact",
        align: "left",
        width: 110,
        render: text => text || "-"
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        align: "left",
        width: 150,
        ellipsis: true,
        render: text => text || "-"
      },
      {
        title: "Amount",
        dataIndex: "amount",
        key: "amount",
        align: "right",
        width: 80,
        render: amount => {
          if (amount) {
            return `₹${parseFloat(amount).toFixed(2)}`;
          }
          return "-";
        }
      },
      {
        title: "Method",
        dataIndex: "method",
        key: "method",
        align: "left",
        width: 100,
        render: method => {
          const methodMap = {
            card: "Card",
            upi: "UPI",
            netbanking: "Net Banking",
            wallet: "Wallet",
            cash: "Cash",
            cardless_emi: "EMI"
          };
          return methodMap[method] || method || "-";
        }
      },
      {
        title: "Status",
        dataIndex: "billing_payment_status",
        key: "billing_payment_status",
        align: "left",
        width: 90,
        render: status => {
          const statusMap = {
            captured: "Captured",
            authorized: "Authorized",
            failed: "Failed",
            refunded: "Refunded",
            pending: "Pending",
            success: "Success",
            completed: "Completed"
          };
          const displayStatus = statusMap[status] || status || "-";

          // Add color coding for status
          let color = "";
          if (
            status === "captured" ||
            status === "success" ||
            status === "completed"
          ) {
            color = "green";
          } else if (status === "failed") {
            color = "red";
          } else if (status === "pending") {
            color = "orange";
          }

          return <span style={{ color }}>{displayStatus}</span>;
        }
      }
    ];

    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={5} className="heading-domain">
              Payments
            </Col>
            <Col className="heading-domain">
              <Button
                type="primary"
                size="small"
                onClick={toggleAddPaymentModal}
              >
                Add payment details manually
              </Button>
            </Col>
          </Row>

          <Row
            type="flex"
            justify="start"
            align="middle"
            gutter={16}
            style={{ marginTop: 16, marginBottom: 16 }}
          >
            <Col>
              <Select
                placeholder="Select Payment Type"
                style={{ width: 200 }}
                allowClear
                value={filters.payment_type || undefined}
                onChange={this.handlePaymentTypeChange}
              >
                <Option value="telemedicine">Telemedicine</Option>
                <Option value="appointment">Appointment</Option>
                <Option value="requested">Requested</Option>
                <Option value="care_package">Care Package</Option>
              </Select>
            </Col>
            <Col>
              <RangePicker
                format="YYYY-MM-DD"
                placeholder={["Start Date", "End Date"]}
                value={
                  filters.start_date && filters.end_date
                    ? [moment(filters.start_date), moment(filters.end_date)]
                    : undefined
                }
                onChange={this.handleDateRangeChange}
                allowClear
              />
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              columns={columns}
              dataSource={payments}
              pagination={false}
              scroll={{ x: 1200 }}
              rowKey={record =>
                record.id ||
                `${record.razorpay_payment_id}_${record.razorpay_order_id}`
              }
              locale={{
                emptyText: "No payments found"
              }}
            />
          </div>
        </div>

        <div className="pagination-wrapper">
          {totalRecords > 10 && (
            <>
              <div className="total-results-wrap">
                <span className="result-count">{totalRecords}</span>
                {totalRecords > 1 ? strings.results : strings.result}
              </div>
              <Pagination
                total={totalRecords}
                current={currentPage}
                onChange={onPageChange}
                pageSize={10}
                defaultCurrent={1}
              />
            </>
          )}
        </div>
      </div>
    );
  }
}